import { render, staticRenderFns } from "./Censo.vue?vue&type=template&id=973cce68"
import script from "./Censo.vue?vue&type=script&lang=js"
export * from "./Censo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports